import { render, staticRenderFns } from "./SidebarArticleItem.vue?vue&type=template&id=40a057fa&"
import script from "./SidebarArticleItem.vue?vue&type=script&setup=true&lang=ts&"
export * from "./SidebarArticleItem.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports